module.exports = __webpack_public_path__ + "img/subversion.2fb72524.png";